module.exports = __webpack_public_path__ + "img/com1.6abb5464.gif";